import React from 'react';
import { render } from 'react-dom';
import moment from 'moment';
import 'moment/locale/fi';

import configureStore from './configureStore';
import Root from './modules/core/Root';

import './index.css';
// import registerServiceWorker from './registerServiceWorker';

moment.locale('fi');

const store = configureStore();

render(
  <Root store={store} />,
  document.getElementById('root')
);


//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js